// Header Component
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { UserActions } from "../UserActions";
import { NavBar } from "../NavBar";
import { Bars3Icon } from "@heroicons/react/24/solid";
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  return (
    <div className=" top-0 w-full bg-white shadow-lg">
      <div className="flex flex-wrap items-center justify-between px-4">
        {/* Logo and Academy Name */}
        <div className="flex items-center space-x-4">
          <Link to="/" className="shrink-0">
            <img
              width="110"
              height="40"
              className=""
              src="../../assets/LOGO.png"
              alt="logo"
            />
          </Link>
          <span className="text-xl sm:text-3xl lg:text-4xl font-semibold italic bg-gradient-to-r from-red-900 via-red-700 to-red-500 text-transparent bg-clip-text leading-tight">
            Shree Krishna Academy
          </span>
          {/* Mobile Toggle Button */}
          <button
            onClick={toggleMenu}
            className="block lg:hidden sm:hidden  focus:outline-none ml-auto  right-4 top-9 z-50"
            aria-label="Toggle Menu"
          >
            <Bars3Icon className="h-8 w-8 text-[#556d89] " />
          </button>
        </div>

        {/* User Actions */}
        <div className="hidden sm:flex items-center mt-2 sm:mt-0 md:mt-0">
          <UserActions />
        </div>
      </div>
      <div className="flex md:justify-center items-center ">
        <NavBar isMenuOpen={isMenuOpen} />
      </div>
    </div>
  );
};
